"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyle = exports.theme = void 0;

var _styledComponents = require("styled-components");

var _grid = _interopRequireDefault(require("./grid"));

var _palette = _interopRequireDefault(require("./palette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  ", "\n  *,\n  *:before,\n  *:after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  button {\n    border: none;\n    border-radius: 0;\n    margin: 0;\n    padding: 0;\n    width: auto;\n    overflow: visible;\n    background: transparent;\n    line-height: normal;\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n    -webkit-appearance: none;\n    cursor: pointer;\n    outline: none;\n  }\n\n  button, a, input[type=range] {\n    &:focus {\n      outline: 1px dashed ", ";\n    }\n  }\n\n  input[type=range] {\n    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */\n    width: 100%; /* Specific width is required for Firefox. */\n    background: transparent; /* Otherwise white in Chrome */\n    margin: 0;\n    padding: 0;\n  }\n\n  input[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n  }\n\n  input[type=range]:focus {\n    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */\n  }\n\n  input[type=range]::-ms-track {\n    width: 100%;\n    cursor: pointer;\n\n    /* Hides the slider so custom styles can be added */\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const theme = _objectSpread({}, _grid.default, {
  palette: _palette.default,
  fonts: {
    primary: "'Montserrat', 'Avenir Next', sans-serif",
    secondary: '-apple-system, BlinkMacSystemFont, Roboto, sans-serif'
  },
  anim: {
    dur: "".concat((1 / 3).toFixed(3), "s")
  }
});
/*
  A helper function to generate a special StyledComponent that handles global styles.
  Normally, styled components are automatically scoped to a local CSS class and
  therefore isolated from other components. In the case of createGlobalStyle,
  this limitation is removed and things like CSS resets or base stylesheets can be applied.
*/


exports.theme = theme;
const GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), ''
/* html, body {
font-family: 'Montserrat', 'Avenir Next', sans-serif;
font-weight: 500;
} */
, props => props.theme.palette.label);
exports.GlobalStyle = GlobalStyle;